import { ContentLayout, TabPanel } from "../../../shared";
import { Box, Tab, Tabs } from "@mui/material";
import { TaxesList, TaxGroupList, useTax } from "..";
import { TabContextProvider } from "../../../store";

export const TaxGroupsAndTaxesList = () => {
  const {
    state,
    currentTab,
    handleTabChange,
    handleModal,
    handleDeleteTaxGroup,
    handleDeleteTaxes,
  } = useTax({ isList: true });
  const { taxGroup, taxes } = state;

  return (
    <>
      <ContentLayout title="Taxes">
        <Box
          className="sticky-Tab"
          sx={{ borderBottom: 1, borderColor: "divider", top: "88px" }}
        >
          <Tabs value={currentTab} onChange={handleTabChange}>
            <Tab label="Tax Group" value="1" />
            <Tab label="Taxes" value="2" />
          </Tabs>
        </Box>
        <TabContextProvider value={currentTab}>
          <TabPanel sx={{ px: "0" }} value="1">
            <TaxGroupList
              data={taxGroup}
              handleModal={handleModal}
              onDelete={handleDeleteTaxGroup}
            />
          </TabPanel>
          <TabPanel sx={{ px: "0" }} value="2">
            <TaxesList
              data={taxes}
              handleModal={handleModal}
              onDelete={handleDeleteTaxes}
            />
          </TabPanel>
        </TabContextProvider>
      </ContentLayout>
    </>
  );
};
